// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2825ebf6","453":"ac3e25cf","455":"e62cc204","977":"cf39d883"}[chunkId] + ".chunk.js";
};